(ns web3.routers.pro
  (:require [web3.lazy :as lazy]))

(def root
  {:paths ["/" {"pro/dashboard" :pro/dashboard}]
   :handlers (lazy/loadable web3.routers.pro-handlers/root)})

(def form-modal
  {:paths ["" {"pro/start" {"/profile" :pro/start
                            "/contact" :pro/contact
                            "/address" :pro/address
                            "/pictures" :pro/pictures
                            "/share-link" :pro/share-link
                            "/review" :pro/review
                            "/premium-offer" :pro/premium-offer
                            "/business-profile" :pro/business-profile
                            "/premium-appearance" :pro/premium-appearance
                            "/premium-confirm" :pro/premium-confirm}}]
   :handlers (lazy/loadable web3.routers.pro-handlers/form-modal)})

(def drawer
  {:paths ["" {"pro" {"/detail" :pro/detail
                      "/offer" :pro/offer}}]
   :handlers (lazy/loadable web3.routers.pro-handlers/drawer)})